export const WISHLIST_ADD_ITEM = 'WISHLIST_ADD_ITEM';
export const WISHLIST_REMOVE_ITEM = 'WISHLIST_REMOVE_ITEM';
export const WISHLIST_LIST = 'WISHLIST_LIST';
export const WISHLIST_LIST_FAILED = 'WISHLIST_LIST_FAILED';
export const WISHLIST_LIST_SUCCESS = 'WISHLIST_LIST_SUCCESS';
